import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { ExplanationEntity } from '../explanation-entity';
import {
  LearningSectionContainerEntityState
} from '../../learning-section/learning-section-container/services/learning-section-container.entity.service';

export const STATE_NAME = 'explanationEntity';

export const ExplanationEntityState: GenericEntityStateClass<ExplanationEntity> =
  createEntityState<ExplanationEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ExplanationEntityService extends EntityService<ExplanationEntity> {
  private learningSectionContainerService = inject(LearningSectionContainerEntityState);

  constructor() {
    super();
    this.resourceType = 'explanations';
    this.stateClass = ExplanationEntityState;

    this.registerRelation('learning-section-containers', this.learningSectionContainerService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ExplanationEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
